import React from 'react'
import { UiCol, UiRowContainer, UiSingleContainer, UiSingleRow } from "../../components/grid-container/GridContainer"
import UiHowSherbetWorkCol from "./UiHowSherbetWorkCol"
import Participate from "../../../../styles/img/participate.png"
import Earn from "../../../../styles/img/earn.png"
import Enjoy from "../../../../styles/img/enjoy-home.png"

export default function UiHowSherbetWork(props) {

    return (
        <>
         <div className='sb-how-sherbet-work'>
            <h3>How Does Sherbet Work?</h3>
            <p>Sherbet is your ultimate earning platform. A limitless opportunity to collect points through work and leisure that you can spend to make your personal enjoyment better than ever. Grow yourself and enjoy every moment! </p>
            <UiRowContainer>
                <UiHowSherbetWorkCol image={Participate} heading="Participate" body="Bring your 'A' game. Connect your brilliance with your passion to be a Sherbet Winner. "/>
                <UiHowSherbetWorkCol image={Earn} heading="Earn" body="And, you can earn when you win in work and spend in your leisure time. There are no limits! "/>
                <UiHowSherbetWorkCol image={Enjoy} heading="Enjoy" body="As your reward points grow, you can spend on what you like, when you like. Check out the Sherbet Shop. "/>
            </UiRowContainer>
            </div>
        </>
    )
}


